import staticPage from 'lib/next/staticPage';
import { AuthRole } from 'types/enums';
import { MyOrdersPage } from 'views/Brands/MyOrders';

export default staticPage({
  role: AuthRole.Onboarded,
  title: 'Select your Testimonial',
})(MyOrdersPage);
